export * from './ps-consulta.component';
